export default __webpack_public_path__ + "static/media/ig-post-7.a8e5ec7f.jpeg";